module.exports = __webpack_public_path__ + "assets/img/cardItem01.e6a8c097.png";